import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../const";
import Navbar from '../../components/Navbar'; 


const ImageInput = ({ label, onCapture, imagePreview }) => {
  const handleCapture = async (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];

      const imageBlob = await compressImage(file);
      const namedFile = new File([imageBlob], 'image.jpg', { type: 'image/jpeg' });

      onCapture(namedFile);
    }
  };

  const openPreview = () => {
    if (imagePreview) {
      window.open(imagePreview, '_blank');
    }
  };

  return (

    <div className="flex flex-col items-center gap-1">
      <label className="text-sm text-gray-600">{label}</label>
      <div className="relative w-24 h-24">
        {imagePreview ? (
          <img
            src={imagePreview}
            alt="preview"
            onClick={openPreview}
            className="absolute w-full h-full object-cover rounded-xl cursor-pointer border-2 border-dashed"
          />
        ) : (
          <label className="w-full h-full flex items-center justify-center border-2 border-dashed rounded-xl cursor-pointer relative overflow-hidden">
            <span className="text-2xl z-10">+</span>
            <input
              type="file"
              accept="image/*"
              capture="environment"
              onChange={handleCapture}
              className="hidden"
            />
          </label>
        )}
      </div>
    </div>

  );
};


// Optional: Basic compression function
const compressImage = (file) => {
  return new Promise((resolve) => {
    const img = new Image();
    const canvas = document.createElement('canvas');
    const reader = new FileReader();

    reader.onload = (e) => {
      img.src = e.target.result;
    };

    img.onload = () => {
      const maxWidth = 800;
      const scale = maxWidth / img.width;
      canvas.width = maxWidth;
      canvas.height = img.height * scale;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      canvas.toBlob((blob) => {
        resolve(blob);
      }, 'image/jpeg', 0.8); // adjust quality if needed
    };

    reader.readAsDataURL(file);
  });
};


const BatchItem = ({ item, onSubmit }) => {
  const [frontImage, setFrontImage] = useState(null);
  const [groupImage, setGroupImage] = useState(null);
  const [rejectedImage, setRejectedImage] = useState(null);
  const [rejectedQty, setRejectedQty] = useState("");
  const submitted = item.status === "completed";

  const getPreview = (file, urlField) => {
    if (file) return URL.createObjectURL(file);
    if (item[urlField]) return item[urlField]; // backend-provided URL
    return null;
  };

  
  const handleSubmit = async () => {
    if (!frontImage || !groupImage) {
      alert("Front and Group images are required.");
      return;
    }

    const token = localStorage.getItem("token");
    const storeId = localStorage.getItem("store");
    const formData = new FormData();
    formData.append("front_image_field", frontImage);
    formData.append("group_image_field", groupImage);
    if (rejectedImage) formData.append("rejected_image_field", rejectedImage);
    if (rejectedQty) formData.append("rejected_qty", rejectedQty);
    formData.append("status", "completed");

    try {
      await axios.patch(`${BASE_URL}/batch_sub_section/${item.id}/update`, formData, {
        headers: {
          Authorization: `Token ${token}`,
          Store: storeId,
        },
      });

      onSubmit(item.id); // optional to track
    } catch (err) {
      console.error("Submit failed", err);
      alert("Failed to submit item.");
    }
  };

return (
  <div className={`border rounded-lg p-3 ${submitted ? 'bg-green-50' : 'bg-white'}`}>
    <div className="flex justify-between items-start mb-2 gap-2">
      <div className="min-w-0"> {/* Added min-w-0 for text wrapping */}
        <h3 className="text-xs font-semibold text-gray-500">SKU: {item.sku}</h3>
        <p className="text-xs font-medium text-gray-800 break-words"> {/* Changed to break-words */}
          {item.sku_lot_name}
        </p>
      </div>
      <div className="flex items-center gap-2">
        <div className="text-right">
          <p className="text-xs text-gray-500">Qty</p>
          <p className="text-sm font-medium">{item.qty}</p>
        </div>
        {submitted && (
          <span className="text-green-600 text-xs">✓</span>
        )}
      </div>
    </div>

    <div className="flex gap-2 overflow-x-auto py-2">
      <ImageInput
        label="Front"
        onCapture={setFrontImage}
        imagePreview={getPreview(frontImage, "front_image_field")}
        submitted={submitted}
        compact
      />
      <ImageInput
        label="Group"
        onCapture={setGroupImage}
        imagePreview={getPreview(groupImage, "group_image_field")}
        submitted={submitted}
        compact
      />
      <ImageInput
        label="Reject"
        onCapture={setRejectedImage}
        imagePreview={getPreview(rejectedImage, "rejected_image_field")}
        submitted={submitted}
        compact
      />
    </div>

    <input
      type="number"
      placeholder="Reject Qty"
      value={rejectedQty}
      onChange={(e) => setRejectedQty(e.target.value)}
      className="w-full border rounded px-2 py-1 text-xs mb-2"
      disabled={submitted}
      max={item.qty}
      min="0"
    />

    {!submitted && (
      <button
        onClick={handleSubmit}
        className="w-full bg-blue-600 text-white py-1 rounded text-xs"
      >
        Submit
      </button>
    )}
  </div>
);
};



const BatchFormPage = () => {
  const { batchId } = useParams();
  const [batchItems, setBatchItems] = useState([]);
    const token = localStorage.getItem("token");
    const storeId = localStorage.getItem("store");

  const fetchBatchItems = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/get_single_batch_data/${batchId}`, {
            headers: {
                Authorization: `Token ${token}`,
                Store: storeId,
        },
      }
        
      );
      setBatchItems(res.data);
    } catch (err) {
      console.error("Failed to fetch batch data", err);
    }
  };

  useEffect(() => {
    fetchBatchItems();
  }, [batchId]);

    const handleItemSubmit = (id) => {
    setBatchItems((prev) =>
        prev.map((item) =>
        item.id === id ? { ...item, status: "completed" } : item
        )
    );
    };

  return (
    <>
      <Navbar title="Batch Update" />

      <div className="p-4 bg-gray-50 min-h-screen w-full">
        <div className="mb-4">
          <h1 className="text-lg font-bold text-gray-800">
            Batch ID: {batchId}
          </h1>
        </div>

        {batchItems.length === 0 ? (
          <p className="text-center text-gray-600 py-8 text-sm">
            All items submitted or no items found.
          </p>
        ) : (
          <div className="grid grid-cols-1 gap-3">
            {batchItems.map((item) => (
              <BatchItem key={item.id} item={item} onSubmit={handleItemSubmit} />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default BatchFormPage;
